import type { ColumnDef } from '@tanstack/react-table';
import type { ReactNode } from 'react';

/** Keep raw accessor values for numeric sorting/filtering; format only the cell. */
export function accuracyColumn<T>(key: keyof T, header: string, render?: (row: T) => ReactNode): ColumnDef<T> {
  return { accessorKey: String(key), header, ...(render ? { cell: ({ row }) => render(row.original) } : {}) };
}
